import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import Immersive3dTourExportRequestRepository from "~/repository/Immersive3dTour/Immersive3dTourExportRequestRepository";

class Immersive3dTourExportRequestStore extends NestStore {
  /**
   * @property {number|null}
   */
  tourId = null;

  /**
   * @property {number|null}
   */
  guestPaymentId = null;

  /**
   * @property {string|null}
   */
  token = null;

  immersive3dTourExportRequestRepository = null;

  constructor() {
    super();

    this.immersive3dTourExportRequestRepository = new Immersive3dTourExportRequestRepository();
  }

  @action
  update() {
    this.isLoading = true;

    const data = {};

    if (this.guestPaymentId) {
      data.guestPaymentId = this.guestPaymentId;
    }

    let query = null;

    if (this.token) {
      query = { token: this.token };
    }

    return this.immersive3dTourExportRequestRepository
      .update(this.tourId, data, query)
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default Immersive3dTourExportRequestStore;
